import { useEffect } from 'react';

// Cesium cancels pointerdown on its canvas, so the browser never sends the mousedown antd popovers close on.
// While `isOpen`, this catches the press in the capture phase, before Cesium does, and closes the popover.
// Only presses inside a Cesium widget count, so the popover's own (portalled) dropdowns never close it.
export const useCloseOnMapPointerDown = (isOpen: boolean, onClose: () => void) => {
  useEffect(() => {
    if (!isOpen) return;
    const closeOnMapPointerDown = (event: PointerEvent) => {
      if (event.target instanceof Element && event.target.closest('.cesium-widget')) onClose();
    };
    document.addEventListener('pointerdown', closeOnMapPointerDown, true);
    return () => document.removeEventListener('pointerdown', closeOnMapPointerDown, true);
  }, [isOpen, onClose]);
};
